import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 1.29rem;
	padding: 1.72rem;
	background-color: ${({ color }) => color};
	color: var(--tooltipTextColor);
	border-radius: var(--spacing-4);
	box-shadow: var(--tooltip-box-shadow);
	max-width: 28rem;
	overflow: auto;
	font-size: var(--paragraph3-font-size);

	> span,
	> a {
		color: var(--tooltipTextColor);
		font-size: var(--paragraph3-font-size);
		word-wrap: break-word;
		hyphens: auto;
	}

	> .tooltip-header {
		color: var(--alwaysWhiteColor);
		font-weight: 500;
		font-size: var(--paragraph1-font-size);
		word-wrap: break-word;
		hyphens: auto;
	}

	> .tooltip-cta-button {
		place-self: end;
	}

	@media ${Breakpoints.mobile} {
		max-width: 80vw;
	}
`;
